import { CoreWebService } from './core-web.service';
import { RequestMethod } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { LoggerService } from './logger.service';
/**
 * Created by josecastro on 7/29/16.
 *
 * Wraps the configuration properties for dotCMS in order to provide an
 * easier way to access the information.
 *
 */
var DEFAULT_REST_PAGE_COUNT = 'DEFAULT_REST_PAGE_COUNT';
var DOTCMS_WEBSOCKET_RECONNECT_TIME = 'dotcms.websocket.reconnect.time';
var DOTCMS_WEBSOCKET_ENDPOINTS = 'dotcms.websocket.endpoints';
var WEBSOCKET_SYSTEMEVENTS_ENDPOINT = 'websocket.systemevents.endpoint';
var DOTCMS_WEBSOCKET_BASEURL = 'dotcms.websocket.baseurl';
var DOTCMS_WEBSOCKET_PROTOCOL = 'dotcms.websocket.protocol';
var DOTCMS_DISABLE_WEBSOCKET_PROTOCOL = 'dotcms.websocket.disable';
var DOTCMS_PAGINATOR_ROWS = 'dotcms.paginator.rows';
var DOTCMS_PAGINATOR_LINKS = 'dotcms.paginator.links';
var EMAIL_REGEX = 'emailRegex';
var DotcmsConfig = (function () {
    /**
     * Initializes this class with the dotCMS core configuration parameters.
     *
     * @param configParams - The configuration properties for the current instance.
     */
    function DotcmsConfig(coreWebService, loggerService) {
        this.coreWebService = coreWebService;
        this.loggerService = loggerService;
        this.waiting = [];
        this.configUrl = 'v1/appconfiguration';
        this.loadConfig();
    }
    DotcmsConfig.prototype.getConfig = function () {
        var _this = this;
        return Observable.create(function (obs) {
            if (_this.configParams) {
                obs.next(_this.configParams);
            }
            else {
                _this.waiting.push(obs);
            }
        });
    };
    DotcmsConfig.prototype.loadConfig = function () {
        var _this = this;
        this.loggerService.debug('Loading configuration on: ', this.configUrl);
        this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: this.configUrl
        })
            .pluck('entity')
            .subscribe(function (res) {
            _this.loggerService.debug('Configuration Loaded!', res);
            _this.configParams = {
                colors: res.config.colors,
                disabledWebsockets: res.config[DOTCMS_DISABLE_WEBSOCKET_PROTOCOL],
                emailRegex: res.config[EMAIL_REGEX],
                license: res.config.license,
                menu: res.menu,
                paginatorLinks: res.config[DOTCMS_PAGINATOR_LINKS],
                paginatorRows: res.config[DOTCMS_PAGINATOR_ROWS],
                websocketBaseURL: res.config[DOTCMS_WEBSOCKET_BASEURL],
                websocketEndpoints: res.config[DOTCMS_WEBSOCKET_ENDPOINTS],
                websocketProtocol: res.config[DOTCMS_WEBSOCKET_PROTOCOL],
                websocketReconnectTime: res.config[DOTCMS_WEBSOCKET_RECONNECT_TIME],
                websocketsSystemEventsEndpoint: res.config[DOTCMS_WEBSOCKET_ENDPOINTS][WEBSOCKET_SYSTEMEVENTS_ENDPOINT]
            };
            _this.loggerService.debug('this.configParams', _this.configParams);
            _this.waiting.forEach(function (obs) { return obs.next(_this.configParams); });
            _this.waiting = null;
            return res;
        });
    };
    return DotcmsConfig;
}());
export { DotcmsConfig };
DotcmsConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DotcmsConfig.ctorParameters = function () { return [
    { type: CoreWebService, },
    { type: LoggerService, },
]; };
//# sourceMappingURL=dotcms-config.service.js.map